// extracted by mini-css-extract-plugin
export default {"root":"PendingTable_root__pWN99","rows":"PendingTable_rows__IICR-","pagination":"PendingTable_pagination__fl7Rq"};